export default __webpack_public_path__ + "static/illustration-content-logo.url-b149f14b22b7ce56e2078309b18346b1.svg";